export default __webpack_public_path__ + "static/media/About_Landing-15.cb9edc7f.png";